import { EMAIL_REGEX } from '../constants';

export const isEmailValid = (emailAddress: string): boolean => {
  return Boolean(emailAddress) && (emailAddress.match(EMAIL_REGEX)?.length ?? 0) > 0;
};
